<template>
  <NavbarHero
    :is-fixed="isHomePage"
    @open-login="openLogin"
    @open-signup="openSignup"
    @close-login="closeLogin"
    @close-signup="closeSignup"
    @change-signup="changeSignup"
    @change-login="changeLogin"
  />

  <div class="flex flex-col md:flex-row min-h-screen">
    <AdminSidebar />

    <main class="flex-1 p-4 md:p-6">
      <slot />
    </main>
  </div>
</template>

<script setup>
import AdminSidebar from "@/components/AdminSidebar.vue";
import { useAuthModal } from "~/composables/useAuthModal";
const route = useRoute();
const isHomePage = computed(() =>
  ["/", "/tr", "/en", "/tr/", "/en/"].includes(route.path)
);
const {
  openLogin,
  openSignup,
  closeLogin,
  closeSignup,
  changeLogin,
  changeSignup,
} = useAuthModal();
</script>
